(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dcs-homepage"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-dcs-page]').forEach((page) => {
    if (page.dataset.dcsReady === 'true') return;
    page.dataset.dcsReady = 'true';

    const unitPrice = Number(page.dataset.unitPrice || 0);
    const quantityInput = page.querySelector('[data-dcs-quantity]');
    const decrease = page.querySelector('[data-dcs-decrease]');
    const increase = page.querySelector('[data-dcs-increase]');
    const subtotal = page.querySelector('[data-dcs-subtotal]');
    const shipping = page.querySelector('[data-dcs-shipping]');
    const total = page.querySelector('[data-dcs-total]');
    const currency = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

    const render = () => {
      const quantity = Math.max(1, Math.min(50, Number(quantityInput.value) || 1));
      quantityInput.value = String(quantity);
      const shippingCents = quantity >= 5 ? 0 : 1299;
      subtotal.textContent = currency.format((unitPrice * quantity) / 100);
      shipping.textContent = shippingCents === 0 ? 'FREE' : currency.format(shippingCents / 100);
      total.textContent = currency.format((unitPrice * quantity + shippingCents) / 100);
      decrease.disabled = quantity === 1;
    };

    decrease.addEventListener('click', () => {
      quantityInput.value = String(Math.max(1, Number(quantityInput.value) - 1));
      render();
    });

    increase.addEventListener('click', () => {
      quantityInput.value = String(Math.min(50, Number(quantityInput.value) + 1));
      render();
    });

    quantityInput.addEventListener('input', render);
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
